<bp-landing-dialog (closePressed)="closeDialog(PasswordResetDialogCloseReason.USER_CLOSE)">
  <div class="dialog-password-reset-content animate__appear-down">
    <bp-landing-dialog-title dialogTitle="Password Recovery"></bp-landing-dialog-title>
    <form [formGroup]="recoveryForm" class="password-reset-form" (ngSubmit)="setPassword()" novalidate>
      <bp-input-logo
        icon="lock"
        placeholder="New password"
        name="password"
        type="password"
        autocomplete="new-password"
        formControlName="password"
        [errorMap]="errorMap"
        [requirementMap]="requirementMap"
      >
      </bp-input-logo>
      <div *ngFor="let error of apiErrors" class="landing-dialog-info-message password-reset-dialog-errors">
        <ng-container *ngIf="error === 'Wrong recovery hash'">Invalid password recovery link</ng-container>
        <ng-container *ngIf="error !== 'Wrong recovery hash'">{{ error }}</ng-container>
      </div>
      <div class="password-reset-dialog-turnstile-widget" id="turnstile-container"></div>
      <div class="password-reset-dialog-button">
        <bp-landing-dialog-button
          type="submit"
          [disabled]="!!passwordErrors || submitButtonDisabled || !turnstileToken"
        >
          Set Password
        </bp-landing-dialog-button>
      </div>
    </form>
  </div>
</bp-landing-dialog>
